<div class="image-editor">
  <angular-cropper #angularCropper
    [cropperOptions]="imageEditor.cropperOptions"
    [imageUrl]="imageUrl">
  </angular-cropper>
  <div class="image-editor__menu-toolbax-options">
    <div class="common-toolbox__inner-container">
      <button class="common-button__icon-md-noborder"
        (click)="zoom('more')">
        <i class="lf-icon-zoom-in common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder"
        (click)="zoom('minus')">
        <i class="lf-icon-zoom-out common-icon__md"></i>
      </button>
    </div>
    <div class="common-toolbox__separator"></div>
    <div class="common-toolbox__inner-container">
      <button class="common-button__icon-md-noborder"
        (click)="moveTo('up')">
        <i class="lf-icon-arrow-up common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder"
        (click)="moveTo('down')">
        <i class="lf-icon-arrow-down common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder"
        (click)="moveTo('left')">
        <i class="lf-icon-arrow-left common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder"
        (click)="moveTo('right')">
        <i class="lf-icon-arrow-right common-icon__md"></i>
      </button>
    </div>
    <div class="common-toolbox__separator"></div>
    <div class="common-toolbox__inner-container">
      <button class="common-button__icon-md-noborder scale-x-[-1]"
        (click)="rotate('-')">
        <i class="lf-icon-rotate common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder"
        (click)="rotate('')">
        <i class="lf-icon-rotate common-icon__md"></i>
      </button>
    </div>
    <div class="common-toolbox__separator"></div>
    <div class="common-toolbox__inner-container">
      <button class="common-button__icon-md-noborder"
        (click)="flip('x')">
        <i class="lf-icon-version common-icon__md"></i>
      </button>
      <button class="common-button__icon-md-noborder rotate-90"
        (click)="flip('y')">
        <i class="lf-icon-version common-icon__md"></i>
      </button>
    </div>
  </div>
  <div class="image-editor__selected-img-container">
    <div class="image-editor__text-info-selected-img">
        <span [afTranslate]="'configure-image.max-size'"></span>
        <span>{{selectedSize.size}}</span>
    </div>
    <img class="image-editor__preview-image"
      [src]="imageEditor.preview"
      alt="Preview view image"
      [ngStyle]="{'height': selectedSize.height, 'width': selectedSize.width}"/>
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="closeEdit()">
      <span class="common-button__text-title"
        [afTranslate]="'common.discard'">_Descartar</span>
    </button>
    <button class="common-button__text"
      (click)="saveAndCloseEdit()">
      <span class="common-button__text-title"
        [afTranslate]="'common.save'">_Guardar</span>
    </button>
  </div>
</div>
